export default {
  mounted: function (el) {
    setTimeout(() => {
      el.focus()
    }, 1)
  }
}
